export default __webpack_public_path__ + "static/media/zawodnik1.0ed8780d.png";